import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    value: Number,
    percentageInterval: {
      type: Number,
      default: 10
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    options: function options() {
      var options = [];

      for (var i = this.percentageInterval; i <= 100; i += this.percentageInterval) {
        options.push({
          value: i,
          label: "".concat(i, "%")
        });
      }

      return options;
    }
  },
  methods: {}
};